module.exports = __webpack_public_path__ + "static/img/shuiya.2c67378f.png";